// after logining getting data

import * as actionTypes from '../actionTypes';

const state = {
  userAuth: '',
};

function loginReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.SET_USER_AUTHENTICATED:
      return {
        ...globalState,
        userAuth: action.token,
      };
    case actionTypes.LOGOUT:
      return {
        ...globalState,
        userAuth: '',
      };
    default:
      return globalState;
  }
}
export { loginReducer as default };
